import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { SuccessResponse, UnlockUserType } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useUnlockIraUser = () => {
  const queryClient = useQueryClient();

  const mutate = async ({ id, isCancelAutoLock }: UnlockUserType) => {
    const { data } = await api.unlockIraUser(id, isCancelAutoLock);

    return data;
  };

  const mutationKey = MutationKeys.unlockIraUser;

  return useMutation<SuccessResponse, AxiosError<ApiError>, UnlockUserType>(
    mutationKey,
    mutate,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.iraUsers);
        queryClient.invalidateQueries(QueryKeys.iraUser);
      },
    },
  );
};
